import { z } from 'zod';

import {
  PAGINATION_PAGE_SIZE_LARGE,
  PAGINATION_SORT_DIRECTION,
} from '~/constants/pagination';

export const DELIVERY_RECENT_CHANGES_ORDER_BY = ['modified_on'] as const;

export const zodDeliveryRecentChangesSearchSchema = z.object({
  limit: z
    .number()
    .int()
    .min(1)
    .max(500)
    .default(PAGINATION_PAGE_SIZE_LARGE)
    .catch(PAGINATION_PAGE_SIZE_LARGE),
  orderBy: z
    .enum(DELIVERY_RECENT_CHANGES_ORDER_BY)
    .default('modified_on')
    .catch('modified_on'),
  page: z.number().int().min(0).default(0).catch(0),
  sortOrder: z.enum(PAGINATION_SORT_DIRECTION).default('DESC').catch('DESC'),
});

export const deliveryRecentChangesSearchDefaults =
  zodDeliveryRecentChangesSearchSchema.parse({});

export type DeliveryRecentChangesSearch = z.infer<
  typeof zodDeliveryRecentChangesSearchSchema
>;
